import React from 'react';

interface DateTemplateProps {
  value: string | null | undefined;
}

/**
 * Formats an ISO date string as localized date.
 */
export const DateTemplate: React.FC<DateTemplateProps> = ({ value }) => {
  if (!value) return <span>-</span>;
  const date = new Date(value);
  return <span>{date.toLocaleDateString()}</span>;
};

/** Syncfusion grid template wrapper for encounterInfo.serviceDate */
export const serviceDateTemplate = (props: any) => (
  <DateTemplate value={props.encounterInfo?.serviceDate} />
);

export default DateTemplate;
